<template>
  <NotificationSettingsBase :connector="connector" display-mode="sending-settings" />
</template>

<script>
import { defineComponent } from 'vue'
import NotificationSettingsBase from '@/components/ClientNotifications/NotificationSettingsBase.vue'

export default defineComponent({
  name: 'NotificationSettingsSendingSettings',
  components: { NotificationSettingsBase },
  props: {
    connector: {
      type: Object,
      required: false,
      default: null,
    },
  },
})
</script>


